import { finish, error } from '../../../modules/customers/actions/request-reactivation';

import api from '../../../api';

export function request(dispatch, { id }) {
    api.post('/customers/' + id + '/request-reactivation').then(
        () => api.get('/customers/' + id).then(
            (customer) => dispatch(finish(id, customer)),
            () => dispatch(finish(id))
        ),
        ({ errors }) => dispatch(error(id, errors))
    );
}
